import { Box, type SxProps, type Theme } from '@mui/material';
import { Star } from '@phosphor-icons/react';
import type { FC } from 'react';

export interface PremiumStarBadgeProps {
    color?: string;
    sx?: SxProps<Theme>;
}

export const PremiumStarBadge: FC<PremiumStarBadgeProps> = ({ color = 'var(--tg-theme-button-color)', sx }) => (
    <Box
        sx={{
            position: 'absolute',
            top: 2,
            right: 2,
            zIndex: 1,
            width: 14,
            height: 14,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: color,
            color: '#fff',
            pointerEvents: 'none',
            boxShadow: '0 1px 3px color-mix(in srgb, var(--tg-theme-text-color) 22%, transparent)',
            ...sx,
        }}
    >
        <Star size={8} weight="fill" />
    </Box>
);
